import { VendorBlocks as VendorBlocksComponent } from '../../../components/Vendor';

export function VendorBlocks() {
  return <VendorBlocksComponent />;
}
